import React from 'react';
import { formatCurrency } from '../../../helpers/formatCurrency';
import { getItemPrice } from './OfferItemRow';

const dotStyle = {
  position: 'absolute',
  left: '-21px',
  top: '4px',
  width: '10px',
  height: '10px',
  borderRadius: '50%',
  background: 'var(--bg-brand-default)',
  border: 'var(--stroke-medium) solid var(--bg-neutral-layer01)',
  boxShadow: '0 0 0 1px var(--bg-brand-default)',
};

export function OrderSummaryCard({
  planName,
  planAmount,
  items,
  discountAmount,
  couponCode,
  finalTotal,
}) {
  const addonItems = items.filter((item) => item.itemId && item.item);

  return (
    <div className="jds-card" style={{ padding: 0 }}>
      <div className="d-flex justify-content-between align-items-center px-5 pt-5">
        <h3 className="jds-title-sm">Detalhes da compra</h3>
        <i
          className="flaticon2-information icon-md text-muted"
          title="Resumo do que será cobrado do cliente"
        ></i>
      </div>

      <div className="px-5 py-5">
        <div
          style={{
            borderLeft: 'var(--stroke-small) solid var(--border-neutral-default)',
            marginLeft: '5px',
            paddingLeft: '21px',
          }}
        >
          <div
            style={{
              position: 'relative',
              marginBottom: addonItems.length ? '20px' : 0,
            }}
          >
            <span style={dotStyle} />
            <div className="jds-title-xs mb-1">Plano</div>
            <div className="d-flex justify-content-between">
              <span className="text-muted">{planName} | 1x item</span>
              <span>{formatCurrency(planAmount)}</span>
            </div>
          </div>

          {addonItems.length > 0 && (
            <div style={{ position: 'relative' }}>
              <span style={dotStyle} />
              <div className="jds-title-xs mb-1">Add-ons</div>
              {addonItems.map((item) => (
                <div key={item.key} className="d-flex justify-content-between">
                  <span className="text-muted">
                    {item.item.name} | {item.quantity}x item
                  </span>
                  <span>
                    {formatCurrency(getItemPrice(item.item) * item.quantity)}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>

        <hr className="jds-divider" />

        {discountAmount > 0 && (
          <div className="d-flex justify-content-between mb-2">
            <span className="text-muted">Desconto (cupom {couponCode})</span>
            <span style={{ color: 'var(--fg-error-strong)' }}>
              − {formatCurrency(discountAmount)}
            </span>
          </div>
        )}
        <div className="d-flex justify-content-between align-items-center">
          <span className="jds-title-xs">Total</span>
          <span className="jds-title-sm">{formatCurrency(finalTotal)}</span>
        </div>
      </div>
    </div>
  );
}
